import { Button, Row, Input } from 'antd'
import { DatabaseOutlined } from '@ant-design/icons';
import GeneralTemplate from './general'

CallWithoutFile = GeneralTemplate({
  InputHandler: ({ startPlugin }) ->
    <div>
      <Row style={{ margin: '40px 0 20px' }}>
        <Button
          style={{ margin: 'auto' }}
          onClick={-> startPlugin()}
          icon={<DatabaseOutlined />}
        >
          Start.
        </Button>
      </Row>
    </div>
  ResponseHandler: ({ response }) ->
    <Row style={{ margin: '40px 0 20px' }}></Row>
})

export default CallWithoutFile
